import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_BEGIN,
  REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_SUCCESS,
  REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_FAILURE,
  REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_DISMISS_ERROR,
} from './constants';

export function exportScInActionOrderReport(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/exportScOrderInfo`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportScInActionOrderReportError() {
  return {
    type: REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_DISMISS_ERROR,
  };
}

export function useExportScInActionOrderReport() {
  const dispatch = useDispatch();

  const { exportScInActionOrderReportPending, exportScInActionOrderReportError } = useSelector(
    state => ({
      exportScInActionOrderReportPending: state.reports.exportScInActionOrderReportPending,
      exportScInActionOrderReportError: state.reports.exportScInActionOrderReportError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportScInActionOrderReport(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportScInActionOrderReportError());
  }, [dispatch]);

  return {
    exportScInActionOrderReport: boundAction,
    exportScInActionOrderReportPending,
    exportScInActionOrderReportError,
    dismissExportScInActionOrderReportError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportScInActionOrderReportPending: true,
        exportScInActionOrderReportError: null,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_SUCCESS:
      // The request is success
      return {
        ...state,
        exportScInActionOrderReportPending: false,
        exportScInActionOrderReportError: null,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_FAILURE:
      // The request is failed
      return {
        ...state,
        exportScInActionOrderReportPending: false,
        exportScInActionOrderReportError: action.data.error,
      };

    case REPORTS_EXPORT_SC_IN_ACTION_ORDER_REPORT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportScInActionOrderReportError: null,
      };

    default:
      return state;
  }
}
